<template>
  <base-form :title="formTitle"
             :loading="loading"
             @submit="onSubmit"
             class="news-letter-form">

    <fg-input :name="$t('generic.name')"
              required
              :placeholder="$t('generic.name')"
              :label="$t('generic.name')"
              v-model="model.name"
              v-validate="'required'"
              :error="getError($t('generic.name'))">
    </fg-input>

    <fg-input required
              :label="$t('generic.description')"
              :error="getError($t('generic.description'))">
          <textarea :placeholder="$t('generic.description')"
                    rows="3"
                    class="form-control"
                    :name="$t('generic.description')"
                    v-validate="'required'"
                    v-model="model.description">
          </textarea>
    </fg-input>
    <fg-input required
              :label="$t('newsletter.form.opt_in_message')"
              :error="getError($t('newsletter.form.opt_in_message'))">
          <textarea :placeholder="$t('newsletter.form.opt_in_message')"
                    rows="3"
                    class="form-control"
                    :name="$t('newsletter.form.opt_in_message')"
                    v-validate="'required'"
                    v-model="model.opt_in_message">
          </textarea>
    </fg-input>
    <dl>
      <div class="list-row bg-gray-50">
        <dt class="list-row-dt">
          {{$t(`generic.candidates`)}}
        </dt>
        <dd class="list-row-dd">
          <base-switch v-model="model.candidates"/>
        </dd>
      </div>
      <div class="list-row bg-white">
        <dt class="list-row-dt">
          {{$t(`generic.clients`)}}
        </dt>
        <dd class="list-row-dd">
          <base-switch v-model="model.clients"/>
        </dd>
      </div>
    </dl>
  </base-form>
</template>
<script>
  export default {
    name: 'news-letter-form',
    props: {
      loading: Boolean,
      data: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        formTitle: this.$t('newsletter.form.newsletter'),
        model: {
          name: '',
          description: '',
          opt_in_message: '',
          candidates: true,
          clients: true,
          clients2: true,
        },
      }
    },
    watch: {
      data: {
        immediate: true,
        handler: function (newVal) {
          if (newVal) {
            this.model = {
              ...this.model,
              ...newVal,
            }
          }
        }
      }
    },
    methods: {
      async onSubmit () {
        let valid = this.$validator.validateAll()
        if (!valid) {
          return
        }
        const model = {
          ...this.model,
        }
        this.$emit('submit', model)
      }
    }
  }
</script>
